/* Terapia Coreana - abas do box de ativos, videos das abas, faixa de beneficios e video do topo.
   Carregado com defer pelas secoes lp-coreana-*. Pode ser incluido mais de uma vez: tudo e idempotente. */
(function () {
  'use strict';
  if (window.LPC && window.LPC.ready) { window.LPC.init(); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadPlay(v) {
    if (!v) return;
    if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; }
    if (reduce) { v.controls = true; return; }
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }

  function ytLoad(btn, mudo) {
    if (!btn || !btn.parentNode) return;
    var id = btn.dataset.lpcYt;
    if (!id) return;
    var box = btn.parentNode;
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&playsinline=1&rel=0&modestbranding=1&loop=1&playlist=' + id + (mudo ? '&mute=1' : '');
    frame.title = btn.getAttribute('aria-label') || 'Video';
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    box._lpcBtn = btn;
    box.replaceChild(frame, btn);
  }

  function ytUnload(box) {
    if (!box || !box._lpcBtn) return;
    var frame = box.querySelector('iframe');
    if (frame) box.replaceChild(box._lpcBtn, frame);
  }

  function tocaPainel(p) {
    if (!p) return;
    loadPlay(p.querySelector('video'));
    if (reduce) return;
    var btn = p.querySelector('[data-lpc-yt]');
    if (btn) ytLoad(btn, true);
  }

  function paraPainel(p) {
    if (!p) return;
    var v = p.querySelector('video');
    if (v && !v.paused) v.pause();
    ytUnload(p.querySelector('.lpc-box-video'));
  }

  function bindTabs(root) {
    if (!root || root._lpc) return; root._lpc = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lpc-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lpc-panel]'));
    if (!panels.length) return;
    var visible = false;

    function current() {
      for (var i = 0; i < panels.length; i++) { if (!panels[i].hidden) return panels[i]; }
      return panels[0];
    }

    function activate(i, focus, fromHash) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-on', on);
      });
      panels.forEach(function (p, j) {
        var on = j === i;
        p.hidden = !on;
        if (!on) paraPainel(p);
      });
      if (focus && tabs[i]) tabs[i].focus();
      if (visible) tocaPainel(panels[i]);
      if (!fromHash && tabs[i] && tabs[i].dataset.anchor && window.history && history.replaceState) {
        history.replaceState(null, '', '#' + tabs[i].dataset.anchor);
      }
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); activate(n, true); }
      });
    });

    var hash = (window.location.hash || '').replace('#', '').toLowerCase();
    if (hash) {
      tabs.forEach(function (t, i) {
        if (t.dataset.anchor === hash) {
          activate(i, false, true);
          root.scrollIntoView({ block: 'start' });
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) tocaPainel(current()); else paraPainel(current());
        });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      visible = true;
      tocaPainel(current());
    }
  }

  function bindMarquee(root) {
    if (!root || root._lpc) return; root._lpc = true;
    var btn = root.querySelector('[data-lpc-marquee-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var paused = root.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Continuar faixa' : 'Pausar faixa');
    });
  }

  function bindHero(v) {
    if (!v || v._lpc) return; v._lpc = true;
    if (reduce) { v.pause(); v.removeAttribute('autoplay'); v.controls = true; }
  }

  function bindYoutube(btn) {
    if (!btn || btn._lpc) return; btn._lpc = true;
    btn.addEventListener('click', function () { ytLoad(btn, false); });
  }

  /* mantem a faixa preta da marca logo abaixo do cabecalho do site, que aparece e some na rolagem */
  function bindBarra(barra) {
    if (!barra || barra._lpc) return; barra._lpc = true;
    var pedido = null;
    function ajusta() {
      pedido = null;
      var topo = 0;
      var cab = document.querySelector('sticky-header, sticky-header-mobile');
      if (cab) {
        var r = cab.getBoundingClientRect();
        if (r.bottom > 0 && r.top <= 1) topo = Math.round(r.bottom);
      }
      barra.style.top = topo + 'px';
    }
    function agenda() {
      if (pedido) return;
      pedido = window.requestAnimationFrame ? requestAnimationFrame(ajusta) : setTimeout(ajusta, 60);
    }
    window.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', agenda);
    ajusta();
  }

  function bindSteps(root) {
    if (!root || root._lpc) return; root._lpc = true;
    var passos = Array.prototype.slice.call(root.querySelectorAll('[data-lpc-step]'));
    var pontos = Array.prototype.slice.call(root.querySelectorAll('[data-lpc-steps-dot]'));
    var conta = root.querySelector('[data-lpc-steps-count]');
    var barra = root.querySelector('[data-lpc-steps-bar]');
    if (passos.length < 2) return;
    var i = 0, timer = null;
    var auto = root.dataset.auto === 'true' && !reduce;
    var espera = parseInt(root.dataset.delay, 10) || 7000;

    function mostra(n) {
      i = (n + passos.length) % passos.length;
      passos.forEach(function (p, j) { p.classList.toggle('is-on', j === i); });
      pontos.forEach(function (d, j) {
        d.classList.toggle('is-on', j === i);
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      if (conta) conta.textContent = (i + 1) + '/' + passos.length;
      if (barra) barra.style.width = Math.round(((i + 1) / passos.length) * 100) + '%';
    }
    function para() { if (timer) { clearInterval(timer); timer = null; } }
    function liga() { if (!auto) return; para(); timer = setInterval(function () { mostra(i + 1); }, espera); }
    function vai(n) { para(); mostra(n); liga(); }

    var ant = root.querySelector('[data-lpc-steps-prev]');
    var prox = root.querySelector('[data-lpc-steps-next]');
    if (ant) ant.addEventListener('click', function () { vai(i - 1); });
    if (prox) prox.addEventListener('click', function () { vai(i + 1); });
    pontos.forEach(function (d, j) { d.addEventListener('click', function () { vai(j); }); });
    root.addEventListener('mouseenter', para);
    root.addEventListener('mouseleave', liga);
    root.addEventListener('focusin', para);
    root.addEventListener('focusout', liga);

    mostra(0);
    liga();
  }

  /* formulario em etapas que envia para o Google Forms */
  function bindPromoForm(raiz) {
    if (!raiz || raiz._lpcF) return; raiz._lpcF = true;
    var caixa = raiz.querySelector('[data-lpc-form]');
    var form = raiz.querySelector('[data-lpc-form-el]');
    if (!caixa || !form) return;
    var campos = Array.prototype.slice.call(form.querySelectorAll('[data-lpc-f]'));
    if (!campos.length) return;
    var conta = form.querySelector('[data-lpc-form-count]');
    var barra = form.querySelector('[data-lpc-form-bar]');
    var ant = form.querySelector('[data-lpc-form-prev]');
    var prox = form.querySelector('[data-lpc-form-next]');
    var enviar = form.querySelector('[data-lpc-form-send]');
    var ok = raiz.querySelector('[data-lpc-form-ok]');
    var i = 0;

    function valor(c) {
      var tipo = c.dataset.type;
      if (tipo === 'escolha') {
        var m = c.querySelector('input[type="radio"]:checked');
        return m ? m.value : '';
      }
      if (tipo === 'aceite') {
        var k = c.querySelector('input[type="checkbox"]');
        return k && k.checked ? k.value : '';
      }
      var campo = c.querySelector('input, textarea');
      return campo ? campo.value.trim() : '';
    }

    function erro(c, texto) {
      var p = c.querySelector('[data-lpc-f-err]');
      if (!p) return;
      p.textContent = texto || '';
      p.hidden = !texto;
    }

    function valida(c) {
      var v = valor(c);
      var obrigatorio = c.dataset.required === 'true';
      var tipo = c.dataset.type;
      if (!v) {
        if (!obrigatorio) { erro(c, ''); return true; }
        erro(c, tipo === 'aceite' ? 'Para participar, é preciso aceitar.' : 'Preencha para continuar.');
        return false;
      }
      if (tipo === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v)) {
        erro(c, 'Confira o e-mail.'); return false;
      }
      if (tipo === 'telefone' && v.replace(/\D/g, '').length < 10) {
        erro(c, 'Confira o telefone com DDD.'); return false;
      }
      if (tipo === 'cpf' && v.replace(/\D/g, '').length !== 11) {
        erro(c, 'O CPF precisa ter 11 números.'); return false;
      }
      erro(c, '');
      return true;
    }

    function marca(c) {
      var alvos = c.querySelectorAll('.lpc-f-opt, .lpc-f-check');
      Array.prototype.forEach.call(alvos, function (l) {
        var input = l.querySelector('input');
        l.classList.toggle('is-on', !!(input && input.checked));
      });
    }

    function mostra(n) {
      i = Math.max(0, Math.min(n, campos.length - 1));
      campos.forEach(function (c, j) { c.classList.toggle('is-on', j === i); });
      marca(campos[i]);
      if (conta) conta.textContent = 'Pergunta ' + (i + 1) + ' de ' + campos.length;
      if (barra) barra.style.width = Math.round(((i + 1) / campos.length) * 100) + '%';
      if (ant) ant.hidden = i === 0;
      var fim = i === campos.length - 1;
      if (prox) prox.hidden = fim;
      if (enviar) enviar.hidden = !fim;
      var foco = campos[i].querySelector('input, textarea');
      if (foco && raiz._lpcAberto) foco.focus();
      raiz._lpcAberto = true;
    }

    campos.forEach(function (c) {
      c.addEventListener('change', function () {
        marca(c);
        erro(c, '');
      });
    });

    mostra(0);
    if (prox) prox.addEventListener('click', function () { if (valida(campos[i])) mostra(i + 1); });
    if (ant) ant.addEventListener('click', function () { mostra(i - 1); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        if (i < campos.length - 1) { if (valida(campos[i])) mostra(i + 1); }
        else if (enviar) enviar.click();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var falhou = -1;
      campos.forEach(function (c, j) { if (!valida(c) && falhou < 0) falhou = j; });
      if (falhou >= 0) { mostra(falhou); return; }
      var destino = (form.getAttribute('action') || '').split('?')[0].replace('/viewform', '/formResponse');
      if (!destino) { erro(campos[campos.length - 1], 'Formulário ainda não conectado.'); return; }
      var dados = new FormData();
      campos.forEach(function (c) {
        if (c.dataset.entry) dados.append(c.dataset.entry, valor(c));
      });
      var rotulo = enviar ? enviar.textContent : '';
      if (enviar) { enviar.disabled = true; enviar.textContent = 'Enviando...'; }
      var fim = function () {
        form.hidden = true;
        if (ok) { ok.hidden = false; ok.setAttribute('tabindex', '-1'); ok.focus(); }
      };
      /* no-cors nao deixa ler a resposta: so a falha de rede chega aqui, e nela a inscricao NAO foi gravada */
      var falha = function () {
        if (enviar) { enviar.disabled = false; enviar.textContent = rotulo; }
        erro(campos[campos.length - 1], 'Não foi possível enviar agora. Confira sua conexão e tente de novo.');
      };
      try {
        fetch(destino, { method: 'POST', mode: 'no-cors', body: dados }).then(fim, falha);
      } catch (err) { falha(); }
    });
  }

  /* video da promocao: comeca sozinho (mudo) quando aparece na tela */
  function bindPromoVideo(v) {
    if (!v || v._lpc) return; v._lpc = true;
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.5 });
    io.observe(v);
  }

  function init() {
    document.querySelectorAll('[data-lpc-tabs]').forEach(bindTabs);
    document.querySelectorAll('[data-lpc-marquee]').forEach(bindMarquee);
    document.querySelectorAll('[data-lpc-hero-video]').forEach(bindHero);
    document.querySelectorAll('[data-lpc-yt]').forEach(bindYoutube);
    document.querySelectorAll('[data-lpc-steps]').forEach(bindSteps);
    document.querySelectorAll('.lpc-promo').forEach(bindPromoForm);
    document.querySelectorAll('[data-lpc-promo-video]').forEach(bindPromoVideo);
    bindBarra(document.querySelector('.nv-section-brandbar'));
  }

  window.LPC = { ready: true, init: init };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
